import { render, staticRenderFns } from "./user-protocol.vue?vue&type=template&id=79d3c5d6&"
import script from "./user-protocol.vue?vue&type=script&lang=js&"
export * from "./user-protocol.vue?vue&type=script&lang=js&"
import style0 from "./user-protocol.vue?vue&type=style&index=0&id=79d3c5d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports